
export const GET_PAYER_DROPDOWN = "/organization/payer/get-payer-dropdown";

export const GET_CLIENTS_DROPDOWN_LISTS_URL = "/client/client-management/get-client-dropdown-listing";

export const GET837RESETCLAIMWISENEWGRID = "automation/load-files-automation";

export const GET_CORRESPONDENCE_CATEGORY_DROPDOWN = "/organization/correspondence-category/get-correspondence-category-dropdown";

export const GET_DOCUMENT_CLASSIFICATION_DROP_DOWN_URL = "/organization/v2/document-classifications/get-document-classification-grid-dropdown"

export const GET_PLB_DETAILS_FROM_NEW_GRID_URL = "/taskmanager/auto-allocate-tasks-plb-adjustments"
export const GET_CLAIM_DETAILS_FROM_NEW_GRID_URL = "/taskmanager/auto-allocate-tasks"
export const GET_LOG_DETAILS_FROM_NEW_GRID_URL = "/job_monitor/auto-allocate-job-log-tasks"
export const GET_GRID_NEW_OR_OLD_URL = "/taskmanager/process-grid-format"